import { showSuccess, showError } from '@/utils/toastHelpers';
import { useCreateRaceType, useUpdateRaceType, useDeleteRaceType } from '@/hooks/useRaceTypes';
import { useEntityActions } from '@/hooks/useEntityActions';
import {
  BIB_NUMBERING_SCOPE_RACE_TYPE,
  normalizeBibNumberingConfig,
} from '@/utils/bibNumbering';
import { RaceType, RaceTypeFormData } from './racetypesmanager.props';

const emptyForm: RaceTypeFormData = {
  name: '',
  distance: '',
  price: '',
  packageType: 'Standard',
  startNumber: '',
  endNumber: '',
  maxBibNumber: '',
  bibNumberingEnabled: true,
  bibNumberingScope: BIB_NUMBERING_SCOPE_RACE_TYPE,
  bibNumberingPoolKey: '',
  maxParticipants: '',
  numberOfZones: 1,
};

export const useRaceTypesActions = (raceId: string) => {
  const createRaceType = useCreateRaceType(raceId);
  const updateRaceType = useUpdateRaceType(raceId);
  const deleteRaceType = useDeleteRaceType(raceId);

  const crud = useEntityActions<RaceType, RaceTypeFormData>({
    emptyForm,
    deleteMutation: deleteRaceType,
    entityName: 'Типот на трка',
  });

  const handleCreate = () => {
    crud.openCreate();
  };

  const handleEdit = (raceType: RaceType) => {
    crud.openEdit(raceType, (rt) => {
      const numbering = normalizeBibNumberingConfig(rt);

      return {
        name: rt.name,
        distance: String(rt.distance),
        price: String(rt.price),
        packageType: rt.packageType,
        startNumber: String(rt.startNumber),
        endNumber: String(rt.endNumber),
        maxBibNumber: String(rt.maxBibNumber),
        bibNumberingEnabled: numbering.bibNumberingEnabled,
        bibNumberingScope: numbering.bibNumberingScope,
        bibNumberingPoolKey: numbering.bibNumberingPoolKey,
        maxParticipants: String(rt.maxParticipants),
        numberOfZones: rt.numberOfZones,
      };
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      ...crud.formData,
      bibNumberingScope: crud.formData.bibNumberingEnabled
        ? crud.formData.bibNumberingScope
        : BIB_NUMBERING_SCOPE_RACE_TYPE,
      bibNumberingPoolKey:
        crud.formData.bibNumberingEnabled &&
        crud.formData.bibNumberingScope !== BIB_NUMBERING_SCOPE_RACE_TYPE
          ? crud.formData.bibNumberingPoolKey.trim()
          : null,
    };

    try {
      if (crud.editingEntity) {
        await updateRaceType.mutateAsync({ id: crud.editingEntity.id, data: payload });
        showSuccess('Успешно ажурирано', 'Типот на трка е успешно ажуриран.');
      } else {
        await createRaceType.mutateAsync(payload);
        showSuccess('Успешно креирано', 'Нов тип на трка е успешно креиран.');
      }
      crud.resetDialog();
    } catch (error) {
      showError(error, 'типот на трка');
    }
  };

  return {
    isDialogOpen: crud.isDialogOpen,
    setIsDialogOpen: crud.setIsDialogOpen,
    editingRaceType: crud.editingEntity,
    deleteTarget: crud.deleteTarget,
    setDeleteTarget: crud.setDeleteTarget,
    formData: crud.formData,
    setFormData: crud.setFormData,
    handleCreate,
    handleEdit,
    handleDelete: crud.handleDelete,
    confirmDelete: crud.confirmDelete,
    handleSubmit,
  };
};
